export class Controller {

    /** @ngInject */
    constructor(GroupsResource) {
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
    }

    remove() {
        this.isSaving = true;
        this.GroupsResource
            .deleteGroups(this.resolve.companyId, this.resolve.groupIds)
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/remove-groups/remove-groups.controller.js